import { updatedDiff } from '@helpers/data';

import { PaymentsSetPaymentSystemStateReducer } from './types';

export const paymentsSetPaymentSystemStateReducer: PaymentsSetPaymentSystemStateReducer =
  (state, action) => {
    const { aggregatorId, paymentSystemId, paymentSystemState } =
      action.payload;

    if (
      !paymentSystemId ||
      !state.paymentsDistributionSettingsItems ||
      !state.paymentsDistributionSettingsProcessedItems
    ) {
      return state;
    }

    const processed = {
      ...state.paymentsDistributionSettingsProcessedItems,
      [aggregatorId]: {
        ...state.paymentsDistributionSettingsProcessedItems[aggregatorId],
        paymentSystems: {
          ...state.paymentsDistributionSettingsProcessedItems[aggregatorId]
            ?.paymentSystems,
          [paymentSystemId]: {
            ...(state.paymentsDistributionSettingsProcessedItems[aggregatorId]
              ?.paymentSystems
              ? state.paymentsDistributionSettingsProcessedItems[aggregatorId]
                  ?.paymentSystems[paymentSystemId]
              : {}),
            paymentSystemState,
          },
        },
      },
    };

    const changes = updatedDiff(
      state.paymentsDistributionSettingsItems,
      processed
    );

    return {
      ...state,
      paymentsDistributionSettingsProcessedItems: {
        ...changes,
      },
    };
  };
